<template>
<div class="my-bookings-item">
  
  <div class="lg:grid lg:grid-cols-12 lg:gap-2">
    <div class="col-span-1 mb-3 md:mb-0 flex items-center">
      <img class="my-bookings-item__image" :src="booking.property.listingMainPhoto" alt="image" />
    </div>

    <!-- <div class="col-span-3 flex gap-2 justify-between items-center mb-1 md:mb-0"> -->
    <div class="col-span-4 grid grid-cols-4 gap-2 mb-1 md:mb-0">
      <div class="col-span-3 my-auto">
        <h4 class="font-semibold">{{ booking.property.listingAddressIn }}</h4>
        <span>{{ booking.property.postcode }}, {{ booking.property.location.name }}</span>
      </div>
      <div class="col-span-1 my-auto text-right lg:text-left">
        <span class="my-bookings-item__price whitespace-nowrap">€ {{ booking.price }}</span>
        <span class="block"> / {{ locales && locales.common && locales.common.mon }}</span>
      </div>
    </div>


    <div class="my-bookings-item__row col-span-2">
      <span class="my-bookings-item__row-definition">{{locales && locales.properties && locales.properties.property_type}}</span>
      <div class="flex flex-col items-end lg:items-center">
        <span>{{ booking.property.type.value }}</span>
        <span class="text-[12px]">{{ booking.property.no_bedrooms + ' bedrooms' }}</span>
      </div>
    </div>


    <div class="my-bookings-item__row col-span-1">
      <span class="my-bookings-item__row-definition">{{locales && locales.common && locales.common.period}}</span>
      <div class="flex md:flex-col">
        <span class="whitespace-nowrap">{{ booking.start_date | formatDate2 }} -</span>
        <span>{{ booking.end_date | formatDate2 }}</span>
      </div>
    </div>


    <div class="my-bookings-item__row col-span-2">
      <span class="my-bookings-item__row-definition">{{locales && locales.common && locales.common.status}}</span>
      <span v-if="booking.is_approved === null || booking.is_approved == 0" class="status-marker status-marker--orange">
        {{locales && locales.common && locales.common.requested}}
      </span>
      <span v-else-if="booking.is_approved == 1 && new Date(booking.start_date) > new Date()" class="status-marker status-marker--green">
        {{locales && locales.common && locales.common.upcoming}}
      </span>
      <span v-else-if="booking.is_approved == 1 && new Date(booking.end_date) < new Date()" class="status-marker status-marker--gray">
        {{locales && locales.common && locales.common.past}}
      </span>
      <span v-else-if="booking.is_approved == -1" class="status-marker status-marker--gray-disabled">
        {{locales && locales.common && locales.common.rejected}}
      </span>
      <span v-else-if="booking.is_approved == -2" class="status-marker status-marker--gray-disabled">
        {{locales && locales.common && locales.common.cancelled}}
      </span>
    </div>

    <!-- <div class="my-bookings-item__eye-icon col-span-1 flex items-center">
      <a :href="'#box-' + booking.id + '-0'" class="my-bookings-item__contact-button" :data-rel="'lightcase:myCollection' + booking.id + 'desktop'">
        <span class="icon-eye icon-orange"></span>
      </a>
      <template v-for='document in booking.documents'>
        <v-lightcase-holder
          :current-document="document"
          :disable-rotate="true"
          :image-src="document.document_url" 
          :name="'box-' + booking.id + '-' + document.id"
        >
        </v-lightcase-holder>
      </template>
    </div> -->

    <div class="my-bookings-item__buttons-block col-span-2">
      <a class="theme-btn theme-btn--small theme-btn--theme" :href="(lang != 'nl' ? '/'+lang : '')+`/bookings/${booking.id}`">
        {{ viewDetailsText }}
        <span class="icon-thin-right text-[20px]"></span>
      </a>
      <div v-if="booking.is_paid" class="my-bookings-item__paid-text">
        <span class="icon-check-circle"></span>
        <p class="">{{ bookingPaidText }}</p>
      </div>
      <button v-else-if="booking.is_approved == 1 && new Date(booking.start_date) > new Date()"
        @click="makePayment(booking.id)"
        class="theme-btn theme-btn--small theme-btn--info">
        {{ makePaymentText }}
      </button>

      <button v-if="booking.is_approved === null || booking.is_approved == 0" @click="deleteBooking(booking.id)" class="theme-btn theme-btn--small theme-btn--destructive">{{ rejectBookingText }}</button>
    </div>

  </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex';
import sweetalert from "sweetalert";

export default {
  props: {
    booking: {
      default: {},
      Type: Object,
    },
    token: {
      default: '',
      Type: String,
    },
    rejectBookingText: {
      default: '',
      Type: String,
    },
    bookingApprovedText: {
      default: '',
      Type: String,
    },
    bookingPaidText: {
      default: '',
      Type: String,
    },
    makePaymentText: {
      default: '',
      Type: String,
    },
    successText: {
      default: '',
      Type: String,
    },
    viewDetailsText: {
      default: '',
      Type: String,
    },
    lang: {
            default: 'nl',
            Type: String,
    },
  },
  data() {
      return {
      };
  },
  computed : {
    ...mapGetters(['locales']),
  },
  methods: {
    makePayment(id) {
      $.ajax({
            url: `/api/property-bookings/booking-payment`,
            method: 'post',
            data: {
              token: this.token, 
              booking_id: id,
            },
            success: function (result, textStatus, xhr) {
              if (xhr.status == 303) {
                window.location.replace(result.redirect);
              }
              if (result && result.url !== undefined || result.redirect !== undefined) {
                var redirect = result.url;
                if (result.redirect) {
                  redirect = result.redirect;
                }
                window.location.replace(redirect);
              }             
            },
            error: function (result) {
              if (result.status == 303) {
                window.location.replace(result.responseJSON.redirect);
              } else{
                  sweetalert('Oops!', 'Error approving', 'error');
              }
            }
        });
    },
    deleteBooking(id) {
      var that = this;
        if (sweetalert) {
          console.log(that.locales);
            sweetalert(that.locales && that.locales['property-bookings'] && that.locales['property-bookings'].do_you_want_to_cancel_booking, {
                buttons: ['Cancel', 'Ok'],
            }).then(value => {
              if (value) {
                  $.ajax({
                      url: `/api/property-bookings/cancel/${id}`,
                      method: 'put',
                      success: (response) => {
                          sweetalert(that.locales && that.locales['property-bookings'] && that.locales['property-bookings'].booking_cancelled, '', 'success').then(value => {
                              window.location.reload();
                          })
                      },
                      error: () => {
                          sweetalert('Oops!', 'Error cancelling', 'error');
                      }
                  });
                }
            });
        }
    },
  },
  mounted() {},
  beforeDestroy() {},
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/MyBookingItem.vue